// extracted by mini-css-extract-plugin
module.exports = {"subHeaderWrapper":"SubHeader-module--subHeaderWrapper--2sqkR"};